<template>
  <v-main v-if="loading || error">
    <app-loading :visible="loading"></app-loading>
    <div v-if="error" class="text-center ma-5">
      Não foi possivel carregar o comprovante
    </div>
  </v-main>
  <div v-else class="document">
    <document-header :account="name" description="Comprovante<br>de Resgate"></document-header>
    <div class="container">
      <div class="row row-wrap">
        <div class="col-7">
          <div class="item-box">
            <div class="item-box-header"><h4>Conta Heppi</h4></div>
            <div class="item-box-content">
              <div class="row">
                <div class="col">
                  <h5>CPF/CNPJ</h5>
                  {{ document | document }}
                </div>
                <div class="col">
                  <h5>Conta Heppi</h5>
                  {{ heppiAccount }}
                </div>
              </div>
              <h5>Nome</h5>
              {{ name }}
            </div>
          </div>
        </div>
        <div class="col-5">
          <div class="item-box">
            <div class="item-box-header"><h4>Valor (R$)</h4></div>
            <div class="item-box-content text-center py-7">
              <div class="amount">
                {{ amount | priceInteger }}<small>,{{ amount | priceCents }}</small>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="item-box mt-4">
        <div class="item-box-header"><h3>Detalhes do resgate</h3></div>
        <div class="item-box-content">
          <div class="row">
            <div v-if="description && description !== 'Saque' && description !== 'Resgate'" class="col-12 px-5 pt-5 pb-1">
              <h5>Descrição</h5>
              <div style="white-space: pre-line">{{ description }}</div>
            </div>
            <div v-if="bank" class="col-5 px-5 pt-5 pb-1">
              <h5>Conta bancária</h5>
              {{ bank.name }}
              <br>
              Agência: {{ bank.agency }}
              <br>
              Conta {{ bank.type }}: {{ bank.account }}
            </div>
            <div v-if="pix" class="col-5 px-5 pt-5 pb-1">
              <h5>PIX</h5>
              {{ pix }}
            </div>
            <div class="col-7 px-5 pt-5 pb-1">
              <h5>Titular</h5>
              {{ titular }}
              <br>
              CPF/CNPJ: {{ document | document }}
            </div>
            <div class="col-5 px-5 pt-1 pb-5 text-uppercase">
              <h5>Realizado em</h5>
              <div class="text-bold">
                {{ date | moment('DD MMMM YYYY HH:mm') }}
              </div>
            </div>
            <div class="col-7 px-5 pt-1 pb-5">
              <h5>Código de autenticação</h5>
              {{ mp }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import AppLoading from '@/components/Loading'
import documentHeader from '@/components/documentHeader'
import { mapGetters } from 'vuex'

export default {
  name: 'transfer',
  components: {
    AppLoading,
    documentHeader
  },
  data () {
    return {
      loading: false,
      error: false,
      name: '',
      heppiAccount: '',
      document: '',
      titular: '',
      amount: 0,
      bank: null,
      pix: null,
      date: '2022-09-26 16:21',
      mp: ''
    }
  },
  computed: {
    ...mapGetters(['transactionById']),
    transactionId () {
      return (this.$route.query && this.$route.query.id) || null
    },
    transactionData () {
      return this.transactionId ? this.transactionById(this.transactionId) : null
    },
    queryAccountId () {
      return (this.$route.query && this.$route.query.accountId) || null
    },
    queryCategory () {
      return (this.$route.query && this.$route.query.category) || null
    }
  },
  async created () {
    let transaction = this.transactionData

    // If transaction not in Vuex store (e.g. opened in new tab), fetch from API using query params
    if (!transaction && this.transactionId && this.queryAccountId) {
      this.loading = true
      try {
        const body = { accountId: this.queryAccountId }
        if (this.queryCategory) {
          body.category = this.queryCategory
        }
        const response = await fetch('https://n8n.heppi.io/webhook/mongodb-payments', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(body)
        })
        if (response.ok) {
          const data = await response.json()
          let transfers = Array.isArray(data) ? data : [data]
          if (transfers.length > 0 && transfers[0].json) {
            transfers = transfers.map(e => e.json)
          }
          transaction = transfers.find(e => {
            const id = e._id && e._id.$oid ? e._id.$oid : e._id
            return id === this.transactionId
          }) || null
        }
        if (!transaction) {
          this.error = true
          this.loading = false
          return
        }
      } catch (error) {
        console.error('[Withdraw] Erro ao buscar transação:', error)
        this.error = true
        this.loading = false
        return
      }
    }

    if (transaction) {
      this.loading = true
      try {
        // sender
        const accountId = this.queryAccountId
        const accountData = await axios.get('accounts/' + accountId + '?api_key=' + accountId, { baseURL: 'https://payment-gateway-api.heppi.io/api/' })
        if (accountData.data) {
          this.name = accountData.data.name
          this.heppiAccount = accountData.data.account_number
          this.document = accountData.data.owner.document
          this.titular = accountData.data.owner.name
          if (!transaction.pix) {
            this.bank = {
              name: accountData.data.owner.bank_data.name,
              agency: accountData.data.owner.bank_data.agency,
              account: accountData.data.owner.bank_data.account_number,
              type: accountData.data.owner.bank_data.type
            }
          }
        } else {
          this.error = true
        }
      } catch (error) {
        console.error('[Withdraw] Erro ao buscar dados da conta:', error)
        this.error = true
        this.loading = false
        return
      }
      if (transaction.pix) {
        this.pix = transaction.pix.pix
      }
      this.amount = transaction.amount
      const paymentDate = transaction.payment_date && transaction.payment_date.$date ? transaction.payment_date.$date : transaction.payment_date
      this.date = this.$moment(paymentDate, 'YYYY-MM-DD[T]HH:mm[.000Z]').subtract(3, 'hours').format('YYYY-MM-DD HH:mm')
      this.description = transaction.description
      this.mp = transaction.withdraw
      this.loading = false
    }
    document.title = this.name + ' - resgate - ' + this.$moment(this.date).format('DD-MM-YYYY HH[h]mm')
  }
}

</script>
